export default __webpack_public_path__ + "static/media/S_S_SALOTAGI.5f2c3d9f.JPG";